import { Link } from "react-router-dom";

export const Book = ({ book }) => {
	const reviews = [book.reviewOne, book.reviewSecond].filter(Boolean);
	return (
		<div className="book-content">
			<div className="book-cover">
				<div className="book-cover-container">
					<img
						src={book.coverImage}
						alt="book_cover_image"
						className="book-cover-style"
					/>

					<div className="book__button">
						<Link
							className="book__button-buy"
							to={book.link}
							target="_blank"
							rel="noopener noreferrer"
						>
							BUY
						</Link>
					</div>
				</div>
			</div>

			<div className="book-overview">
				<h1 className="book-title">{book.title}</h1>
				<h3 className="book-publication">
					<span>Publication:</span> {book.publication}
				</h3>
				<h3 className="book-year">
					<span>{`Copyright Year: `}</span>
					{book.year}
				</h3>
				<p className="book-about">{book.description}</p>

				{reviews.length > 0 && (
					<div className="book-review">
						<h3>
							<span>Review:</span>
						</h3>
						{reviews.map((review, index) => (
							<p
								className="book-review"
								key={index}
							>
								<a
									className="book-review--link"
									href={review.match(/https?:\/\/\S+/)?.[0]}
									target="_blank"
									rel="noopener noreferrer"
								>
									{review}
								</a>
							</p>
						))}
					</div>
				)}
			</div>
		</div>
	);
};
